import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const ENDPOINT = "/legal";

export const legalOnboardingService = {
    sendOnboardData({ mode, productDetails, promptDescription, lang }) {
        if (mode) {
            console.warn("RETURNING fake {legal} onboarding for now");
            return Promise.resolve({});
        }
        return ajaxCall
            .post(`${ENDPOINT}/onboarding`, { mode, productDetails, promptDescription, lang })
            .catch(handleErrorByMessage());
    },
};
